import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { NavigationBarToolBoxHome } from '$comp/navigation-bar-tool-box/components/home'

export function ToolboxModal({ isOpen }: { isOpen: boolean }) {
  const isDesktop = useIsDesktopSize()

  return (
    <BottomDrawer
      isTransparent
      alwaysIsDrawer
      isOpen={isOpen}
      onClose={closeCurrentModal}
      bottomSafeAreaColor="veryLightGray"
      paperProps={{
        sx: isDesktop
          ? {
              margin: 'unset',
              right: 0,
              maxWidth: 360,
            }
          : null,
      }}
    >
      <NavigationBarToolBoxHome onClose={closeCurrentModal} />
    </BottomDrawer>
  )
}
